// Add to WishList Products from Checkout
{

    async function addProductsToWishListFromCart(){
        
        if(cartProductHandless.length > 0){
            for (let handle of cartProductHandless) {
                let isInWishList = false;
                window.wishlistItems?.forEach((wishListElem)=>{
                    if(wishListElem.product.handle == handle){
                        isInWishList = true;
                    }
                });
    
                if(!isInWishList){
                    try {
                        await WishlistKing.addWishlistItem({
                            productHandle: handle
                        });
                    } catch (error) {
                        console.error(`Error adding product ${handle} to wishlist:`, error);
                    }
                }
            }
        }
    }
  
    window.onload = function(){
        let url = window.location.href;
        if(url.indexOf('apps/wishlist?addFromCart=1') != -1){
            let interval = setInterval(()=>{
                if(window.WishlistKing){
                    clearInterval(interval);
                    addProductsToWishListFromCart();
                }
            },500)
        }
    }
  }